import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { UndoToast } from './UndoToast';
import { ForcePasswordChangeModal } from './ForcePasswordChangeModal';
import { useAuthStore } from '../lib/authStore';

export function AppLayout() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const user = useAuthStore((s) => s.user);

  // Drawer beim Routenwechsel automatisch schliessen
  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  // ESC schließt den Drawer
  useEffect(() => {
    if (!mobileOpen) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setMobileOpen(false);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [mobileOpen]);

  return (
    <>
      {/* Hamburger oben links — nur auf Mobile sichtbar */}
      <button
        type="button"
        className="mobile-menu-btn"
        onClick={() => setMobileOpen(true)}
        aria-label="Menü öffnen"
      >
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
          <line x1="3" y1="6" x2="21" y2="6" />
          <line x1="3" y1="12" x2="21" y2="12" />
          <line x1="3" y1="18" x2="21" y2="18" />
        </svg>
      </button>

      <Sidebar className={mobileOpen ? 'is-open' : ''} />

      {/* Dimmer hinter der Sidebar nur sichtbar wenn offen */}
      {mobileOpen && (
        <div
          className="sidebar-scrim"
          onClick={() => setMobileOpen(false)}
          aria-hidden="true"
        />
      )}

      <main className="app-main">
        <Outlet />
      </main>

      <UndoToast />

      {/* Sperrt die App komplett, bis das Force-Change-Passwort gesetzt ist. */}
      {user?.password_change_required && <ForcePasswordChangeModal user={user} />}
    </>
  );
}
